export const GlobalFilter = ({ filter, setFilter }: any) => {
  return (
    <div className='global-filter'>
      <input
        className='form__item__input font-h5-regular'
        placeholder='Search'
        value={filter || ''}
        onChange={(e) => setFilter(e.target.value)}
      ></input>
    </div>
  );
};
